import React from "react";
import '../index.css';
import Header from '../components/Header';
import Footer from "../components/Footer"; 
import homebanner from "../assets/home-banner.png"; 
import Pagetitlesection from "../components/pagetitlesection";

function Verifyprofile() {
  return (
    <>
      <Header />
      <div className="page-body-container">
        <Pagetitlesection title="Verify Your Profile" backgroundImage={homebanner} />

      <div className="md:container mx-auto px-6 sm:px-6 py-10">
 <div className="space-y-6 text-gray-800 text-base leading-relaxed">
<p>
  If you see a verified name on your profile, it means that Giffypedia confirmed that this is the authentic original profile for this public figure, company or brand.
</p>
<p>
  Keep in mind that verified profiles are for well-known, often searched Pages and profiles. Not all public figures, celebrities and brands on Giffypedia have verified names.
</p>
<p>
  <b>For more information contact </b> 
  <a href="mailto:giffypedia@gmail.com" className="text-indigo-600 hover:underline">
    giffypedia@gmail.com
  </a>
</p>

  </div>
  <br/>
   
 
</div>

        <Footer />
      </div>
    </>
  );
}

export default Verifyprofile;
